import { pageTitle } from 'ember-page-title';
import { t } from 'ember-intl';
import { variation } from 'ember-launch-darkly';
import BasicDropdownWormhole from 'ember-basic-dropdown/components/basic-dropdown-wormhole';

import PageGlobalError from 'hcp/components/page/global-error';

<template>
  {{pageTitle (t "product.name") separator=" | " prepend=true replace=false}}

  {{#if (variation "hcp-ui-maintenance-mode")}}
    <PageGlobalError @variant="maintenance-mode" @error={{@controller.model}} />
  {{else}}
    {{outlet}}
  {{/if}}

  <BasicDropdownWormhole />
</template>
